import { Component } from '@angular/core';

@Component({
    selector: 'jhi-jumbotron',
    templateUrl: './jumbotron.component.html',
    styleUrls: ['./jumbotron.component.scss']
})
export class JumbotronComponent {



}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/jumbotron/jumbotron.component.ts